export default __webpack_public_path__ + "static/media/cep_preview.8ac15a39.gif";